/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_PlaceholderInputs */

const id_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/login!`)
};

const ms_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/login!`)
};

const da_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/login!`)
};

const de_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/login!`)
};

const en_us2_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/login!`)
};

const es_es2_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/login!`)
};

const es_mx2_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/login!`)
};

const fil_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/login!`)
};

const fr_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour /auth/login !`)
};

const it_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao /auth/login!`)
};

const hu_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szia /auth/login!`)
};

const nl_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/login!`)
};

const no_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/login!`)
};

const pl_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj /auth/login!`)
};

const pt_br2_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/login!`)
};

const pt_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/login!`)
};

const ro_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salut /auth/login!`)
};

const fi_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/login!`)
};

const sv_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/login!`)
};

const vi_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào /auth/login!`)
};

const tr_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba /auth/login!`)
};

const cs_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahoj /auth/login!`)
};

const bg_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравейте /auth/login!`)
};

const ru_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, /auth/login!`)
};

const uk_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привіт /auth/login!`)
};

const ar_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا /auth/login!`)
};

const hi_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमस्ते /auth/login!`)
};

const th_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดี /auth/login!`)
};

const ja_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんにちは /auth/login!`)
};

const zh_cn2_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/login!`)
};

const zh_hant1_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/login！`)
};

const ko_auth_login_placeholder = /** @type {(inputs: Auth_Login_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/auth/login에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Hello /auth/login!" |
*
* @param {Auth_Login_PlaceholderInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const auth_login_placeholder = /** @type {((inputs?: Auth_Login_PlaceholderInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_PlaceholderInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_auth_login_placeholder(inputs)
	if (locale === "ms") return ms_auth_login_placeholder(inputs)
	if (locale === "da") return da_auth_login_placeholder(inputs)
	if (locale === "de") return de_auth_login_placeholder(inputs)
	if (locale === "en-US") return en_us2_auth_login_placeholder(inputs)
	if (locale === "es-ES") return es_es2_auth_login_placeholder(inputs)
	if (locale === "es-MX") return es_mx2_auth_login_placeholder(inputs)
	if (locale === "fil") return fil_auth_login_placeholder(inputs)
	if (locale === "fr") return fr_auth_login_placeholder(inputs)
	if (locale === "it") return it_auth_login_placeholder(inputs)
	if (locale === "hu") return hu_auth_login_placeholder(inputs)
	if (locale === "nl") return nl_auth_login_placeholder(inputs)
	if (locale === "no") return no_auth_login_placeholder(inputs)
	if (locale === "pl") return pl_auth_login_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_auth_login_placeholder(inputs)
	if (locale === "pt") return pt_auth_login_placeholder(inputs)
	if (locale === "ro") return ro_auth_login_placeholder(inputs)
	if (locale === "fi") return fi_auth_login_placeholder(inputs)
	if (locale === "sv") return sv_auth_login_placeholder(inputs)
	if (locale === "vi") return vi_auth_login_placeholder(inputs)
	if (locale === "tr") return tr_auth_login_placeholder(inputs)
	if (locale === "cs") return cs_auth_login_placeholder(inputs)
	if (locale === "bg") return bg_auth_login_placeholder(inputs)
	if (locale === "ru") return ru_auth_login_placeholder(inputs)
	if (locale === "uk") return uk_auth_login_placeholder(inputs)
	if (locale === "ar") return ar_auth_login_placeholder(inputs)
	if (locale === "hi") return hi_auth_login_placeholder(inputs)
	if (locale === "th") return th_auth_login_placeholder(inputs)
	if (locale === "ja") return ja_auth_login_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_auth_login_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_auth_login_placeholder(inputs)
	return ko_auth_login_placeholder(inputs)
});
export { auth_login_placeholder as "auth.login.placeholder" }